<template>
  <div>
    <div
      class="form-group variable-selector">
      <vue-single-select
        :placeholder="''"
        class="selection-left"
        v-model="variable"
        v-on:input="$emit('input', variable)"
        :options="variables"
        :disabled="disabled"
        :option-label="'label'"
        :max-results="getMaxResults"/>
      <btn-pill
        v-has-feature="'Taxonomy'"
        :disabled="disabled"
        style="white-space: nowrap"
        @click="showModal = true"
        btn-size="s"
        btn-type="secondary">
        <font-awesome-icon
          :icon="icon.tags"/>
        {{ $t('variables.tags') }}
      </btn-pill>
    </div>
    <variable-selector-modal
      v-if="showModal"
      v-on:close="showModal = false"
      v-model="variable"
      v-on:input="$emit('input', variable)"
      v-on:selectedTagsChanged="selectedTagsChanged"
      :variables="variables"
      :tagged-variables="taggedVariables"
      :selected-tags="selectedTags"
      :tree="tree"/>
  </div>
</template>

<script>
import VariableSelectorModal from '@/components/variable/VariableSelectorModal';
import vSelect from 'vue-select';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faTags } from '@fortawesome/pro-regular-svg-icons';
import BtnPill from '@/components/shared/buttons/BtnPill';
import VueSingleSelect from 'vue-single-select';
import variableSelectorMixin from '@/components/explorer/variableSelectorMixin';

export default {
  name: 'VariableSelector',
  components: {
    BtnPill,
    vSelect,
    VariableSelectorModal,
    FontAwesomeIcon,
    VueSingleSelect
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    variables: {
      type: Array,
      default: () => []
    },
    taggedVariables: {
      type: Array,
      default: () => []
    },
    tree: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.variable = value;
      }
    }
  },
  mixins: [
    variableSelectorMixin
  ],
  data () {
    return {
      variable: this.value,
      showModal: false,
      icon: {
        tags: faTags
      },
      selectedTags: []
    };
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .selection-left {
    width: 100%;
    margin: 1px;
    margin-right: $sp-margin-small;
  }

  .variable-selector {
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .v-select.v-select {
    padding-left: $sp-margin-small;
    padding-right: $sp-margin-small;
  }

  /deep/ .single-select-wrapper {
    margin-bottom: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/VariableSelector.vue